export const toInteger = (value: any) => {
  return (value * 100).toFixed(1)
}
